import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams, useNavigate } from 'react-router-dom';
import '../index.css';
import { logout } from "../utils/logout";
import Logo from '../assets/img/logo.png';
import 'bootstrap-icons/font/bootstrap-icons.css';
import api from "../api/api";

function Navbar() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
    async function fetchUser() {
      try {
        const res = await api.get("/auth/me");
        setUser(res.data);
      } catch (err) {
        if (err.response?.status !== 401) {
            console.error(err);
        }
        setUser(null);
      } finally {
        setLoading(false);
      }
    }

    fetchUser();
  }, []);

  const handleLogout = async () => {
    await logout();
    setUser(null);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading) return null;

  const isLoggedIn = !!user;
  const isAdmin = user?.role === "admin";

    
    return (
        <nav className={`navbar navbar-expand-lg sticky-top ${scrolled ? "scrolled" : ""}`}>
            <div className='container'>
                <Link to="/" className="navbar-brand">
                    <img src={Logo} alt="LCWE" className="navbar-logo" />
                </Link>
                {!isLoggedIn ? (
                    <Link to="/login" className="d-lg-none ms-auto me-4 btn btn-primary mx-2">Sign In</Link>
                    ) : (
                    <>
                        <div className="d-lg-none ms-auto me-4 dropdown">
                            <a
                            className="navbar-icon bi-person smoothscroll dropdown-toggle dropdown-menu-light"
                            id="user" role="button"
                            data-bs-toggle="dropdown"
                            >
                            </a>
                            <div className="dropdown-menu dropdown-menu-light"  aria-labelledby="user">
                                <Link className="dropdown-item" to="/swip">SWIP</Link>
                                <Link className="dropdown-item" to="/today-irrigation">View Today's Irrigation</Link>
                                <Link className="dropdown-item" to="/irrigation">Irrigation Schedule</Link>
                                <Link className="dropdown-item" to="/" onClick={handleLogout}>Logout</Link>
                            </div>
                        </div>
                    </>
                    )}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"  aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <button type="button" className="btn-close ms-auto d-lg-none" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-label="Close" ></button>
                    <div className="navbar-nav ms-lg-5 me-lg-auto">
                        <Link to="/" className="nav-item nav-link">Home</Link>
                        <Link to="/about" className="nav-item nav-link">About Us</Link>
                        <Link to="/projects" className="nav-item nav-link">Projects</Link>
                        <Link to="/team" className="nav-item nav-link">Our Team</Link>
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle" id="navbarLightDropdownMenuLink" role="button" data-bs-toggle="dropdown">Activities</a>
                            <div className="dropdown-menu" aria-labelledby="navbarLightDropdownMenuLink">
                                <Link className="dropdown-item" to="/events">Events & Webinars</Link>
                                <Link className="dropdown-item" to="/training">Training Courses</Link>
                                <Link className="dropdown-item" to="/workshops">Workshops</Link>
                            </div>
                        </div>
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle" id="navbarLightDropdownMenuLink1" role="button" data-bs-toggle="dropdown">Resources</a>
                            <div className="dropdown-menu"  aria-labelledby="navbarLightDropdownMenuLink1">
                                <Link className="dropdown-item" to="/publications">Publications</Link>
                                <Link className="dropdown-item" to="/reports">Reports</Link>
                                <Link className="dropdown-item" to="/livinglab">Living Lab</Link>
                                <Link className="dropdown-item" to="/blogs">Blogs</Link>
                            </div>
                        </div>
                    </div>

                    {isAdmin && (
                    <div className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                        Admin
                        </a>
                        <div className="dropdown-menu">
                        <Link className="dropdown-item" to="/admin/contents">Contents</Link>
                        <Link className="dropdown-item" to="/admin/team">Team</Link>
                        </div>
                    </div>
                    )}

                    
                    {/* {!isLoggedIn ? ( */}
                    {/* <Link to="https://seep.lcwe-lb.com" className="btn btn-primary py-2 px-4 ms-3 mx-2">SEEP</Link> */}
                    <a href="https://seep.lcwe-lb.com" target="_blank" rel="noopener noreferrer" className="btn btn-primary py-2 px-4 ms-3 mx-2">SEEP</a>
                    {/* ) : (
                    <>
                        <div className="d-none d-lg-block dropdown">
                            <a
                            className="navbar-icon bi-person smoothscroll dropdown-toggle dropdown-menu-light"
                            id="user" role="button"
                            data-bs-toggle="dropdown"
                            >
                            </a>
                            <div className="dropdown-menu dropdown-menu-light"  aria-labelledby="user">
                                <Link className="dropdown-item" to="/swip">SWIP</Link>
                                <Link className="dropdown-item" to="/today-irrigation">View Today's Irrigation</Link>
                                <Link className="dropdown-item" to="/irrigation">Irrigation Schedule</Link>
                                <Link className="dropdown-item" to="/" onClick={handleLogout}>Logout</Link>
                            </div>
                        </div>
                    </>
                    )} */}
                    <Link to="/contact" className="btn btn-primary py-2 px-4 ms-3">Contact Us</Link>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;